import api from "../../utils/api";


export function getDictItemByCode(code) {
  return api.get(`/system/dict/item/${code}`);
}
